import React from "react";
import {NOOP} from "../utils/NOOP.jsx";

export const ProviderContext = React.createContext({
    providerDetails: null,
    log: NOOP
});
